import type { Coordinate } from './coordinate';

export function setGeoJsonProperty(feature: GeoJSON.Feature, name: string, value: any) {
  let properties = feature.properties;
  if (!properties) {
    properties = {};
    feature.properties = properties;
  }
  properties[name] = value;
}

export function getGeoJsonPropertyNumber(feature: GeoJSON.Feature, name: string) {
  const properties = feature.properties;
  if (!properties) return;
  const value = properties[name];
  if (typeof value === 'number') return value;
}

export function getGeoJsonPropertyBoolean(feature: GeoJSON.Feature, name: string) {
  const properties = feature.properties;
  if (!properties) return;
  const value = properties[name];
  if (typeof value === 'boolean') return value;
}

export function getGeoJsonPropertyText(feature: GeoJSON.Feature, name: string) {
  const properties = feature.properties;
  if (!properties) return;
  const value = properties[name];
  if (typeof value === 'string') return value;
}

export function getGeoJsonPropertyCoordinate(feature: GeoJSON.Feature, name: string) {
  const properties = feature.properties;
  if (!properties) return;
  const value = properties[name];
  if (typeof value === 'object') return value as Coordinate;
}
